import Vue from "vue";
import VueRouter from "vue-router";

import ErrorsRoutes from "@/router/errors";
import PublicRoutes from "@/router/public";
import PrivateRoutes from "@/router/private";

Vue.use(VueRouter);

var allRoutes = [];
allRoutes = allRoutes.concat(ErrorsRoutes, PublicRoutes, PrivateRoutes);

export default new VueRouter({
  mode: "history",
  routes: allRoutes
});
